import React from "react";

const EmptyState = ({
  icon,
  text,
  buttonLabel,
  onButtonClick,
  subTitle,
}) => {
  return (
    <div className="empty-state">
      {icon}
      
   <p
  className="empty-state-text"
  dangerouslySetInnerHTML={{ __html: text }}
>
      </p>
      {subTitle && <p className="grey-text">{subTitle}</p>}
      {buttonLabel && onButtonClick && (
        <button className="empty-state-button" onClick={onButtonClick}>
          {buttonLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
